import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "max-mobile-width" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col text-end" }
const _hoisted_5 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "card-header transport-card-header" }
const _hoisted_9 = { class: "card-body p-0 pt-3" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col col-8 min-width-date-time" }
const _hoisted_12 = { class: "load-place-name" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "col col-4 min-width-date-time" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-primary" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col col-8 min-width-date-time" }
const _hoisted_21 = { class: "unload-place-name" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "col col-4 min-width-date-time" }
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "text-primary" }
const _hoisted_28 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col" }, [
          _createElementVNode("img", {
            src: 'img/logo.png',
            height: "70"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'login', query: { logout: 1 }},
            class: "btn btn-secondary"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "k-icon k-i-logout" }, null, -1),
              _createElementVNode("span", null, "Odhlásit", -1)
            ])),
            _: 1
          })
        ])
      ]),
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.cases.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cases, (c) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "card mb-5 p-4",
                      key: c.caseId,
                      role: "button",
                      onClick: ($event: any) => (_ctx.openDetail(c.caseId))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", null, _toDisplayString(c.document), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              (!c.isLoaded)
                                ? (_openBlock(), _createElementBlock("strong", _hoisted_13, _toDisplayString(c.loadAddressName), 1))
                                : _createCommentVNode("", true),
                              (c.isLoaded)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(c.loadAddressName), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.formatDateTime(c.loadTime)), 1),
                              (c.currentLoadDelayTime)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                                    _cache[3] || (_cache[3] = _createTextVNode(" (")),
                                    _createElementVNode("strong", _hoisted_18, _toDisplayString(_ctx.formatDateTime(c.currentLoadDelayTime)), 1),
                                    _cache[4] || (_cache[4] = _createTextVNode(") "))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "row mt-2 mb-2 transport-arrow-line" }, [
                          _createElementVNode("div", { class: "col col min-width-date-time" }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("i", { class: "k-icon k-i-arrow-down" })
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              (!c.isLoaded)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(c.subjectAddressName), 1))
                                : _createCommentVNode("", true),
                              (c.isLoaded)
                                ? (_openBlock(), _createElementBlock("strong", _hoisted_23, _toDisplayString(c.subjectAddressName), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.formatDateTime(c.unloadTime)), 1),
                              (c.currentUnloadDelayTime)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                    _cache[6] || (_cache[6] = _createTextVNode(" (")),
                                    _createElementVNode("strong", _hoisted_27, _toDisplayString(_ctx.formatDateTime(c.currentUnloadDelayTime)), 1),
                                    _cache[7] || (_cache[7] = _createTextVNode(") "))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ], 8, _hoisted_7))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.cases.length <= 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[9] || (_cache[9] = [
                  _createElementVNode("p", { class: "text-center" }, "Aktuálně nemáte přiřazenu žádnou přepravu", -1)
                ])))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}